export const uk = {
    accept: 'Применить',
    cancel: 'Отмена',
    title: 'Введите логин, либо UID пользователя'
};
